import React, { Component } from "react";
import axios from "axios";
import LogoPSMD from "./_img/PSMD1.png";
import LogoPSMT from "./_img/PSMT.png";
import LogoPSAL from "./_img/PSAL.png";
import { CSHome } from "./_config.js";
import { genURL } from "./_getjson";
// import GetFile from './CustomFunction/GetFile/GetFile.js';
//import { useClearBrowserCache } from 'react-clear-browser-cache';

function parseJwt(token) {
  var base64Url = token.split(".")[1];
  var base64 = base64Url.replace("-", "+").replace("_", "/");
  return JSON.parse(window.atob(base64));
}
// import useClearCache from "react-clear-cache";

var user = "",
  phone = "",
  nickname = "",
  email = "",
  address = "",
  userpass = "";
// const { isLatestVersion, emptyCacheStorage } = useClearCache();

function logo() {
  var logo;
  switch (localStorage.getItem("company")) {
    case "PSMD":
      logo = LogoPSMD;
      break;
    case "PSMT":
      logo = LogoPSMT;
      break;
    case "PSAL":
      logo = LogoPSAL;
      break;
    default:
      break;
  }
  return logo;
}

var nameComTH = "",
  nameComEN = "",
  addrCom = "",
  telCom = "",
  faxCom = "",
  managerCom = "";

class Company extends React.Component {
  getImage = async () => {
    console.log("getImage called - starting API call to CSHome(1)");
    try {
      const res = await axios.get(CSHome(1));
      console.log("getImage API response:", res);
      console.log("getImage API response data:", res.data);
      console.log("getImage API response data type:", typeof res.data);
      console.log(
        "getImage API response data isArray:",
        Array.isArray(res.data)
      );

      if (res.data && res.data.length > 0) {
        console.log("getImage - processing response data");
        nameComTH = res.data[0].COMPANYNAMETH || "";
        nameComEN = res.data[0].COMPANYNAMEEN || "";
        addrCom = res.data[0].ADDRESS || "";
        telCom = res.data[0].TELEPHONE || "";
        faxCom = res.data[0].FAXNUMBER || "";
        managerCom = res.data[0].MANAGER || "";

        console.log("getImage - extracted data:", {
          nameComTH,
          nameComEN,
          addrCom,
          telCom,
          faxCom,
          managerCom,
        });

        this.setState({ nameComTH: nameComTH });
      } else {
        console.log("getImage - no data or empty array received");
      }
    } catch (error) {
      console.log("getImage error:", error);
      console.log("getImage error message:", error.message);
      console.log("getImage error response:", error.response);
      // Set default values if API fails
      nameComTH = "";
      nameComEN = "";
      addrCom = "";
      telCom = "";
      faxCom = "";
      managerCom = "";
    }
  };
  componentDidMount() {
    // Call API immediately when component mounts
    this.getImage();

    // Optional: also listen to window load if needed
    if (
      window.location.pathname === "/" ||
      window.location.pathname === "/home"
    ) {
      window.addEventListener("load", this.getImage);
    }
    // console.log("checkoftxt", localStorage.getItem("checkoftxt"))
    // GetFile("CSAPDEPOSIT.xml")
    //   .then((url) => {
    //     console.log("url", url);
    //   })
    //   .catch((err) => {
    //     console.log("err", err);
    //   });
  }

  componentWillUnmount() {
    // Remove event listener to prevent memory leak
    window.removeEventListener("load", this.getImage);
  }

  render() {
    return (
      <div className="panel-body">
        <div className="col-md-2 hidden-sm " align="center">
          <img src={logo()} width="100%" className="" />
        </div>
        <div className="col-md-10 col-sm-12" align="right">
          <div className="form-inline" style={{ width: "100%" }}>
            <span className="input-group-text">
              {" "}
              <b> รหัสบริษัท : </b>{" "}
            </span>
            <input
              type="text"
              className="form-control"
              defaultValue={nameComTH}
              style={{ width: "60%" }}
            />
            <input
              type="text"
              className="form-control"
              defaultValue="-"
              style={{ width: "20%" }}
            />
          </div>
          <div className="clearfix" align="center"></div>
          <div className="form-inline" style={{ width: "100%" }}>
            <span className="input-group-text" id="basic-addon1">
              {" "}
              <b> บริษัท : </b>{" "}
            </span>
            <input
              type="text"
              className="form-control"
              defaultValue={nameComTH}
              style={{ width: "80%" }}
            />
          </div>
          <div className="clearfix" align="center"></div>
          <div className="form-inline" style={{ width: "100%" }}>
            <span className="input-group-text" id="basic-addon2">
              {" "}
              <b> บริษัท (EN) : </b>{" "}
            </span>
            <input
              type="text"
              className="form-control"
              defaultValue={nameComEN}
              style={{ width: "80%" }}
            />
          </div>
          <div className="clearfix" align="center"></div>
          <div className="form-inline" style={{ width: "100%" }}>
            <span className="input-group-text">
              {" "}
              <b> ที่อยู่ : </b>{" "}
            </span>
            <input
              type="text"
              className="form-control"
              defaultValue={addrCom}
              style={{ width: "80%" }}
            />
          </div>
          <div className="clearfix" align="center"></div>
          <div className="form-inline" style={{ width: "100%" }}>
            <span className="input-group-text" id="basic-addon1">
              {" "}
              <b> โทรศัพท์ : </b>{" "}
            </span>
            <input
              type="text"
              className="form-control"
              defaultValue={telCom}
              style={{ width: "80%" }}
            />
          </div>
          <div className="clearfix" align="center"></div>
          <div className="form-inline" style={{ width: "100%" }}>
            <span className="input-group-text" id="basic-addon1">
              {" "}
              <b> โทรสาร : </b>{" "}
            </span>
            <input
              type="text"
              className="form-control"
              defaultValue={faxCom}
              style={{ width: "80%" }}
            />
          </div>
          <div className="clearfix" align="center"></div>
          <div className="form-inline" style={{ width: "100%" }}>
            <span className="input-group-text" id="basic-addon1">
              {" "}
              <b> ชื่อลงทะเบียน : </b>{" "}
            </span>
            <input
              type="text"
              className="form-control"
              defaultValue={managerCom}
              style={{ width: "80%" }}
            />
          </div>
          <div className="clearfix" align="center"></div>
          <div className="form-inline" style={{ width: "100%" }}>
            <span className="input-group-text" id="basic-addon3">
              {" "}
              <b> Token : </b>{" "}
            </span>
            <input
              type="text"
              className="form-control"
              defaultValue={localStorage.getItem("Token")}
              style={{ width: "80%" }}
            />
          </div>
        </div>
      </div>
    );
  }
}

class Profile extends Component {
  state = {
    S_nickname: nickname,
    S_address: address,
    S_phone: phone,
    S_email: email,
    S_userpass1: userpass,
    S_userpass2: userpass,
    TextAlert: "",
  };

  inputChange = (event) => {
    const { id, value } = event.target;
    switch (id) {
      case "S_nickname":
        this.setState({ S_nickname: value });
        break;
      case "S_address":
        this.setState({ S_address: value });
        address = value;
        break;
      case "S_phone":
        this.setState({ S_phone: value });
        break;
      case "S_email":
        this.setState({ S_email: value });
        break;
      case "S_userpass1":
        this.setState({ S_userpass1: value });
        break;
      case "S_userpass2":
        this.setState({ S_userpass2: value });
        break;
      default:
        break;
    }
  };

  onSaveCkick = (event) => {
    if (this.state.S_userpass1 === this.state.S_userpass2) {
      const para = new URLSearchParams();
      para.append("user", user);
      para.append("userpass", this.state.S_userpass1);
      para.append("mynameth", this.state.S_nickname);
      para.append("email", this.state.S_email);
      para.append("telephone", this.state.S_phone);
      para.append("address", this.state.S_address);
      axios.post(CSHome(2), para).then((res) => {
        if (res.data > 0) {
          this.setState({ TextAlert: "บันทึกข้อมูลสำเร็จ" });
        } else {
          this.setState({ TextAlert: "บันทึกข้อไม่มูลสำเร็จ" });
        }
        setTimeout(() => {
          this.setState({ TextAlert: "" });
        }, 5000);
      });
    } else {
      this.setState({ TextAlert: "รหัสผ่านไม่ตรงกัน" });
      setTimeout(() => {
        this.setState({ TextAlert: "" });
      }, 5000);
    }
  };

  render() {
    var style1 = {
      marginRight: "0",
      textAlign: "right",
      padding: "5px",
    };
    var styleinput = {
      width: "50%",
      textAlign: "left",
      align: "left",
    };
    return (
      <form>
        <div className="panel-body">
          <div className="col-md-2 hidden-sm">
            <img src={logo()} width="100%" className="" />
          </div>
          <div className="col-md-10 col-sm-12" align="left">
            <div className="form-inline" style={{ width: "100%" }}>
              <span className="col-sm-2 col-form-label" style={style1}>
                {" "}
                <b> ชื่อพนักงาน : </b>{" "}
              </span>
              <input
                type="text"
                className="form-control"
                defaultValue={this.state.S_nickname}
                style={styleinput}
                id="S_nickname"
                onChange={this.inputChange}
              />
            </div>
            <div className="clearfix" align="center"></div>
            <div className="form-inline" style={{ width: "100%" }}>
              <span className="col-sm-2 col-form-label" style={style1}>
                {" "}
                <b> ที่อยู่ : </b>{" "}
              </span>
              <input
                type="text"
                className="form-control"
                defaultValue={this.state.S_address}
                style={styleinput}
                id="S_address"
                onChange={this.inputChange}
              />
            </div>
            <div className="clearfix" align="center"></div>
            <div className="form-inline" style={{ width: "100%" }}>
              <span className="col-sm-2 col-form-label" style={style1}>
                {" "}
                <b> โทรศัพท์ : </b>{" "}
              </span>
              <input
                type="text"
                className="form-control"
                defaultValue={this.state.S_phone}
                style={styleinput}
                id="S_phone"
                onChange={this.inputChange}
              />
            </div>
            <div className="clearfix" align="center"></div>
            <div className="form-inline" style={{ width: "100%" }}>
              <span className="col-sm-2 col-form-label" style={style1}>
                {" "}
                <b> อีเมล์ : </b>{" "}
              </span>
              <input
                type="text"
                className="form-control"
                defaultValue={this.state.S_email}
                style={styleinput}
                id="S_email"
                onChange={this.inputChange}
              />
            </div>
            <div className="clearfix" align="center"></div>
            <div /* className="form-inline" */ style={{ width: "100%" }}>
              <span className="col-sm-2 col-form-label" style={style1}>
                {" "}
                <b> รหัสผ่าน : </b>{" "}
              </span>
              <input
                type="password"
                className="form-control"
                defaultValue={this.state.S_userpass1}
                style={styleinput}
                id="S_userpass1"
                onChange={this.inputChange}
              />
            </div>
            <div className="clearfix" align="center"></div>
            <div className="form-inline" style={{ width: "100%" }}>
              <span className="col-sm-2 col-form-label" style={style1}>
                {" "}
                <b> ยืนยันรหัสผ่าน : </b>{" "}
              </span>
              <input
                type="password"
                className="form-control"
                defaultValue={this.state.S_userpass2}
                style={styleinput}
                id="S_userpass2"
                onChange={this.inputChange}
              />
            </div>
            <div className="clearfix"></div>
            <div
              className="form-inline"
              align="right"
              style={{ width: "100%" }}
            >
              <span className="col-sm-2 col-form-label" style={style1}>
                {" "}
                <b> </b>{" "}
              </span>
              <button
                type="button"
                className="btn btn-success"
                style={{ textAlign: "center" }}
                onClick={this.onSaveCkick}
              >
                {" "}
                บันทึก{" "}
              </button>
              <b> {this.state.TextAlert}</b>
            </div>
          </div>
        </div>
      </form>
    );
  }
}

export default class Home extends Component {
  state = {
    HomeShow: <Company />,
    Menu1: "active",
    Menu2: "",
    Menu3: "",
    TimeOut: parseJwt(localStorage.getItem("Token")).exp * 1000,
    timestamp: 0,
    varII: 1,
  };
  componentDidMount() {
    console.log("Home componentDidMount called");
    console.log("Home initial state:", this.state);

    let tokenparse = parseJwt(localStorage.getItem("Token"));
    console.log("Home tokenparse:", tokenparse);
    console.log("Home user code:", tokenparse.User.CODE);

    this.usercheckortherpermisson(tokenparse.User.CODE);
    // console.log("checkoftxt", localStorage.getItem("checkoftxt"))
  }
  async usercheckortherpermisson(usercode) {
    console.log("usercheckortherpermisson called with usercode:", usercode);
    //เช็คเปิดปิด textbox
    let Url = "CSMSTRIGHTUSER/GETUSERCODE?Usercode=" + usercode;
    console.log("url checkoftxt", genURL(Url));

    await axios
      .get(genURL(Url), { timeout: 5000 })
      .then((res1) => {
        console.log("usercheckortherpermisson API response:", res1);
        console.log("usercheckortherpermisson API response data:", res1.data);
        if (res1.data) {
          localStorage.setItem("checkoftxt", JSON.stringify(res1.data[0]));
          console.log(
            "usercheckortherpermisson - saved to localStorage:",
            res1.data[0]
          );
        }
      })
      .catch((err) => {
        console.log("CSMSTRIGHTUSER" + err);
        console.log("usercheckortherpermisson error details:", err);
      });
  }
  ActiveMenu1 = (event) => {
    console.log("ActiveMenu1 clicked - switching to Company");
    this.setState({
      Menu1: "active",
      Menu2: "",
      Menu3: "",
      HomeShow: <Company />,
    });
  };
  ActiveMenu2 = (event) => {
    console.log("ActiveMenu2 clicked - switching to Profile");
    this.setState({
      Menu1: "",
      Menu2: "active",
      Menu3: "",
      HomeShow: <Profile />,
    });
  };
  ActiveMenu3 = (event) => {
    console.log("ActiveMenu3 clicked - logout");
    this.setState({ Menu1: "", Menu2: "", Menu3: "active", HomeShow: "" });
  };
  render() {
    console.log("Home render called");
    console.log("Home current state:", this.state);
    console.log("Home HomeShow component:", this.state.HomeShow);

    var style1 = {
      lineHeight: "8px",
    };
    // const contextValue = useClearBrowserCache();
    // console.log(contextValue)

    return (
      <div className="panel-body ACHome">
        <ul className="nav nav-tabs">
          <li className={this.state.Menu1} onClick={this.ActiveMenu1}>
            <a href="#" style={style1}>
              {" "}
              ข้อมูลบริษัท{" "}
            </a>
          </li>
          <li className={this.state.Menu2} onClick={this.ActiveMenu2}>
            <a href="#" style={style1}>
              {" "}
              ข้อมูลพนักงาน{" "}
            </a>
          </li>
          <li className={this.state.Menu3} onClick={this.ActiveMenu3}>
            <a href="/logout" style={style1}>
              {" "}
              ออกจากระบบ{" "}
            </a>
          </li>
        </ul>
        {this.state.HomeShow}
      </div>
    );
  }
}
